<template>
    <div>
        <span v-if="reconnectingCall && !inCall" class="call-banner cursor opacity green">
            Reconnecting to call
        </span>

        <span v-if="reconnectingCallLeader" class="call-banner cursor opacity red">
            Initiator is gone and reconnecting to call
        </span>

        <span  v-if="hasMessage" class="call-banner cursor opacity" :class="{'red': red, 'green': green}">
            {{message}}
        </span>
        
    </div>
</template>

<script>
import SessionManager from '../Manager/Session.manager'
import KeyboardManager from '../Manager/keyboard.manager'
import { serverBus } from '../main'
import Global  from '../scripts/Global'
import ChannelApi from '../scripts//api/channel.api'
import UserApi from '../scripts/api/user.api'
import VueSignals from '@/scripts/VueSignals'

export default {
  data: function() {
    return {      
        reconnectingCall: false,
        reconnectingCallLeader: false,
        hasMessage: false,
        message: '',
        red: false,
        green: false,
        inCall: false,
    }
  },  
  
  mounted(){

    serverBus.$on("inCall", (status) => {
        this.inCall = status           
    })

    serverBus.$on("ongoing_channel_call_id", (data) => { 
        if(data.length > 0){
            this.reconnectingCall = true
        }else {
            this.reconnectingCall = false
        } 
    })
    
     serverBus.$on("reconnecting_leader", (status) => { 
        this.reconnectingCallLeader = status
    })

    serverBus.$on("remove_call_message", (status) => { 
      this.hasMessage = false
      this.message = ''
      this.red = false
      this.green = false
    })    


    serverBus.$on("rtc_call_banner_message_green", (message) => { 
        this.hasMessage = true
        this.message = message
        this.green = true
       setTimeout(()=>{
           Global.globalValue("remove_call_message", true)
       },2000) 
    })

    serverBus.$on("rtc_call_banner_message_red", (message) => { 
        this.hasMessage = true
        this.message = message
        this.red = true
        this.inCall = true
       setTimeout(()=>{
           Global.globalValue("remove_call_message", true)
       },10000) 
    })    
    
  },
  methods: {
      
  }
}
</script>